// extracted by mini-css-extract-plugin
module.exports = {"UsersHeader":"UsersHeader_UsersHeader__26tpW","UsersIcon":"UsersHeader_UsersIcon__2lyRe","UsersHeader_title":"UsersHeader_UsersHeader_title__CtOFO"};